import { request } from "../http/api-client";

export interface MFASetupResponse {
  success: boolean;
  data: {
    method: string;
    secret: string;
    qrCode: string;
    backupCodes: string[];
    isVerified: boolean;
  };
  message: string;
}

export interface MFAVerifyResponse {
  success: boolean;
  data: {
    success: boolean;
    backupCodes?: string[];
  };
  message: string;
}

export interface MFADisableResponse {
  success: boolean;
  data: {
    success: boolean;
  };
  message: string;
}

export interface MFAStatus {
  enabled: boolean;
  method?: string;
  lastUsed?: string;
}

export async function setupMFA(method: "TOTP" = "TOTP"): Promise<MFASetupResponse> {
  const res = await request<MFASetupResponse>(`/api/v1/auth/mfa/setup`, {
    method: "POST",
    body: {
      method,
    },
  });
  return res;
}

export async function verifyMFA(code: string): Promise<MFAVerifyResponse> {
  const res = await request<MFAVerifyResponse>(`/api/v1/auth/mfa/verify`, {
    method: "POST",
    body: {
      code,
    },
  });
  return res;
}

export async function disableMFA(password: string): Promise<MFADisableResponse> {
  const res = await request<MFADisableResponse>(`/api/v1/auth/mfa/disable`, {
    method: "POST",
    body: {
      password,
    },
  });
  return res;
}

export async function getMFAStatus(): Promise<MFAStatus> {
  try {
    const res = await request<{ success: boolean; data: MFAStatus }>(`/api/v1/auth/mfa/status`, {
      method: "GET",
    });
    return res.data;
  } catch (error) {
    // If status endpoint doesn't exist, assume MFA is disabled
    return { enabled: false };
  }
}